import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, DrawingManager } from '@react-google-maps/api';
import { FaDrawPolygon, FaRegCircle, FaRegHandPaper } from "react-icons/fa";

const DrawingPolygonMap = ({ onPolygonComplete, initialPolygon }) => {
  const [drawingMode, setDrawingMode] = useState(null);
  const [shapes, setShapes] = useState([]);
  const [oldShape, setOldShape] = useState(null);
  const mapRef = useRef(null);
  const polygonDrawn = useRef(false); // Prevent double rendering
  const center = { lat: 13.0567, lng: 80.2098 };
  const initialFitDone = useRef(false);
const hasAutoFitDone = useRef(false);
const polygonRef = useRef(null);




useEffect(() => {
  if (mapRef.current && initialPolygon && !hasAutoFitDone.current) {
    try {
      const geo = JSON.parse(initialPolygon);
      const coordinates = geo.coordinates?.[0] || [];
      if (!coordinates.length) return;

      const path = coordinates.map(([lng, lat]) => ({ lat, lng }));

      // Clear old shapes
      shapes.forEach(s => s.setMap(null));

      const polygon = new window.google.maps.Polygon({
        paths: path,
        map: mapRef.current,
        fillColor: '#FF0000',
        fillOpacity: 0.4,
        strokeWeight: 2,
        editable: true,
      });

      // Fit bounds
      const bounds = new window.google.maps.LatLngBounds();
      path.forEach(coord => bounds.extend(coord));
      mapRef.current.fitBounds(bounds);

      setShapes([polygon]);
      setOldShape(polygon);
      polygonDrawn.current = true;
      hasAutoFitDone.current = true;

      // Update handler
      const updatePolygon = () => {
        const updatedPath = polygon.getPath().getArray().map(p => [p.lng(), p.lat()]);
        if (
          updatedPath.length &&
          (updatedPath[0][0] !== updatedPath[updatedPath.length - 1][0] ||
            updatedPath[0][1] !== updatedPath[updatedPath.length - 1][1])
        ) {
          updatedPath.push([...updatedPath[0]]);
        }

        const updatedGeoJson = {
          type: "Polygon",
          coordinates: [updatedPath],
        };

        onPolygonComplete(JSON.stringify(updatedGeoJson));
      };

      polygon.getPath().addListener('set_at', updatePolygon);
      polygon.getPath().addListener('insert_at', updatePolygon);

    } catch (err) {
      console.error("❌ Error parsing polygon:", err);
    }
  }
}, [initialPolygon]);


useEffect(() => {
  polygonDrawn.current = false;
}, []);


const onMapLoad = (map) => {
  mapRef.current = map;

  // reset if needed (optional)
  // if (!initialPolygon) return;

  // if (!polygonDrawn.current && initialPolygon) {
    try {
      const geo = JSON.parse(initialPolygon);
      const coordinates = geo.coordinates?.[0];
      if (!coordinates) return;

      const path = coordinates.map(([lng, lat]) => ({ lat, lng }));

      const polygon = new window.google.maps.Polygon({
        paths: path,
        map,
        fillColor: '#FF0000',
        fillOpacity: 0.4,
        strokeWeight: 2,
        editable: true,
      });

      // Listener for edits
      const updatePolygon = () => {
        const updatedPath = polygon.getPath().getArray().map(p => [p.lng(), p.lat()]);
        if (
          updatedPath.length &&
          (updatedPath[0][0] !== updatedPath[updatedPath.length - 1][0] ||
            updatedPath[0][1] !== updatedPath[updatedPath.length - 1][1])
        ) {
          updatedPath.push([...updatedPath[0]]);
        }

        const updatedGeoJson = {
          type: "Polygon",
          coordinates: [updatedPath],
        };

        onPolygonComplete(JSON.stringify(updatedGeoJson));
      };

      polygon.getPath().addListener('set_at', updatePolygon);
      polygon.getPath().addListener('insert_at', updatePolygon);

      // Zoom to polygon
      const bounds = new window.google.maps.LatLngBounds();
      path.forEach(coord => bounds.extend(coord));
      map.fitBounds(bounds);

      setShapes([polygon]);
      setOldShape(polygon);
      polygonDrawn.current = true;

    } catch (err) {
      console.error("Invalid polygon:", err);
    }
  // }
};






// const handlePolygonComplete = (polygon) => {
//   // Clear any existing drawn polygons
//   // shapes.forEach(({ shape }) => shape.setMap(null));
//   shapes.forEach(s => s.setMap(null)); // 
//   setShapes([]);
//   polygonRef.current = polygon;
//   polygonDrawn.current = true;

//   const path = polygon.getPath().getArray().map((latLng) => [latLng.lng(), latLng.lat()]);

//   // Ensure polygon is closed
//   if (
//     path.length &&
//     (path[0][0] !== path[path.length - 1][0] || path[0][1] !== path[path.length - 1][1])
//   ) {
//     path.push([...path[0]]);
//   }

//   // Convert to GeoJSON format
//   const geoJson = {
//     type: "Polygon",
//     coordinates: [path],
//   };

//   onPolygonComplete(JSON.stringify(geoJson)); // ✅ send GeoJSON to parent

//   // setShapes([{ type: 'polygon', shape: polygon }]);
// setShapes([polygon]); // ✅ same as your other code

//   // Update handler when polygon is edited
//   const updatePolygon = () => {
//     const updatedPath = polygon.getPath().getArray().map(p => [p.lng(), p.lat()]);
//     if (
//       updatedPath.length &&
//       (updatedPath[0][0] !== updatedPath[updatedPath.length - 1][0] ||
//         updatedPath[0][1] !== updatedPath[updatedPath.length - 1][1])
//     ) {
//       updatedPath.push([...updatedPath[0]]);
//     }

//     const updatedGeoJson = {
//       type: "Polygon",
//       coordinates: [updatedPath],
//     };

//     onPolygonComplete(JSON.stringify(updatedGeoJson));
//   };

//   polygon.getPath().addListener('set_at', updatePolygon);
//   polygon.getPath().addListener('insert_at', updatePolygon);
// };

const handlePolygonComplete = (polygon) => {
  // Clear old shapes
  shapes.forEach(s => s.setMap(null));
  setShapes([]);
  polygonRef.current = polygon;
  polygonDrawn.current = true;

  const path = polygon.getPath().getArray().map((latLng) => [latLng.lng(), latLng.lat()]);

  // Ensure polygon is closed
  if (
    path.length &&
    (path[0][0] !== path[path.length - 1][0] || path[0][1] !== path[path.length - 1][1])
  ) {
    path.push([...path[0]]);
  }

  // Convert to GeoJSON
  const geoJson = {
    type: "Polygon",
    coordinates: [path],
  };

  onPolygonComplete(JSON.stringify(geoJson));

  // ✅ Store only the Google Maps polygon instance
  setShapes([polygon]);

  // Update handler when polygon is edited
  const updatePolygon = () => {
    const updatedPath = polygon.getPath().getArray().map(p => [p.lng(), p.lat()]);
    if (
      updatedPath.length &&
      (updatedPath[0][0] !== updatedPath[updatedPath.length - 1][0] ||
        updatedPath[0][1] !== updatedPath[updatedPath.length - 1][1])
    ) {
      updatedPath.push([...updatedPath[0]]);
    }

    const updatedGeoJson = {
      type: "Polygon",
      coordinates: [updatedPath],
    };

    onPolygonComplete(JSON.stringify(updatedGeoJson));
  };

  polygon.getPath().addListener('set_at', updatePolygon);
  polygon.getPath().addListener('insert_at', updatePolygon);
};



  const handleCircleComplete = (circle) => {
    setShapes(prev => [...prev, circle]);
    setOldShape(circle);
    setDrawingMode(null);
    const center = circle.getCenter();
    const radius = circle.getRadius();
    onPolygonComplete?.(`Circle(Center: ${center.lat().toFixed(6)}, ${center.lng().toFixed(6)}, Radius: ${radius.toFixed(2)}m)`);
  };

  const removeLastShape = () => {
    const last = shapes.pop();
    if (last) last.setMap(null);
    setShapes([...shapes]);
  };

  const clearMap = () => {
    shapes.forEach(s => s.setMap(null));
    setShapes([]);
    polygonDrawn.current = false;
  };

const restoreOld = () => {
  if (!oldShape || !mapRef.current) return;

  // 🧹 Clear existing shapes
  shapes.forEach(s => s.setMap(null));
  setShapes([]);

  if (oldShape instanceof window.google.maps.Polygon) {
    const path = oldShape.getPath().getArray();

    const restored = new window.google.maps.Polygon({
      paths: path,
      map: mapRef.current,
      fillColor: '#FF0000',
      fillOpacity: 0.4,
      strokeWeight: 2,
      editable: true,
    });

    setShapes([restored]);
    setOldShape(restored);

    // ✅ KEY: Fit map to polygon bounds
    const bounds = new window.google.maps.LatLngBounds();
    path.forEach(coord => bounds.extend(coord));
    mapRef.current.fitBounds(bounds); // ← This line moves the map
  }

  if (oldShape instanceof window.google.maps.Circle) {
    const center = oldShape.getCenter();
    const radius = oldShape.getRadius();

    const restored = new window.google.maps.Circle({
      center,
      radius,
      map: mapRef.current,
      fillColor: '#00FF00',
      fillOpacity: 0.3,
      strokeWeight: 2,
      editable: true,
    });

    setShapes([restored]);
    setOldShape(restored);

    // ✅ Center on circle
    mapRef.current.setCenter(center);
    mapRef.current.setZoom(14);
  }
};




  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: 'flex', gap: '10px', marginBottom: 20 }}>
      <button type="button" onClick={removeLastShape} style={btnStyle('#007bff')}>Remove Newly Added Line</button>
<button type="button" onClick={clearMap} style={btnStyle('#dc3545')}>Clear Map</button>
<button type="button" onClick={restoreOld} style={btnStyle('#28a745')}>Restore Old Map</button>

      </div>

      <div style={{ position: 'relative' }}>
        <div style={floatingIconsStyle}>
          <IconButton icon={<FaDrawPolygon />} title="Draw Polygon" active={drawingMode === 'polygon'} onClick={() => setDrawingMode('polygon')} />
          {/* <IconButton icon={<FaRegCircle />} title="Draw Circle" active={drawingMode === 'circle'} onClick={() => setDrawingMode('circle')} /> */}
          <IconButton icon={<FaRegHandPaper />} title="Stop Drawing" active={drawingMode === null} onClick={() => setDrawingMode(null)} />
        </div>
{window.google && (
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '500px' }}
    center={center}
    zoom={11}
    onLoad={onMapLoad}
  >
    {window.google.maps?.drawing && drawingMode && (
      <DrawingManager
        key={drawingMode}
        drawingMode={drawingMode}
        onPolygonComplete={handlePolygonComplete}
        onCircleComplete={handleCircleComplete}
        options={{
          drawingControl: false,
          polygonOptions: {
            fillColor: '#FF0000',
            fillOpacity: 0.4,
            strokeWeight: 2,
            editable: true,
          },
          circleOptions: {
            fillColor: '#00FF00',
            fillOpacity: 0.3,
            strokeWeight: 2,
            editable: true,
          },
        }}
      />
    )}
  </GoogleMap>
)}

      </div>
    </div>
  );
};

const btnStyle = (bg) => ({
  backgroundColor: bg,
  color: '#fff',
  padding: '8px 12px',
  borderRadius: 6,
  border: 'none',
});

const floatingIconsStyle = {
  position: 'absolute',
  top: 10,
  left: '60%',
  transform: 'translateX(-50%)',
  zIndex: 10,
  display: 'flex',
  gap: '10px',
  background: '#fff',
  padding: '6px 12px',
  borderRadius: '8px',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
};

const IconButton = ({ icon, title, active, onClick }) => (
  <div
    title={title}
    onClick={onClick}
    style={{
      backgroundColor: active ? '#007bff' : 'transparent',
      color: active ? '#fff' : '#000',
      padding: 4,
      borderRadius: 6,
      cursor: 'pointer',
    }}
  >
    {icon}
  </div>
);

export default DrawingPolygonMap;
